import { format } from 'date-fns';
import colors from 'seagull/foundations/colors.module.scss';
import { utils } from '~/utils';
export const historicAgreementStatsWidgetTextsPath = 'pages.dashboard.historicAgreementStatsWidget';
const agreementsColor = colors.blue700;
const proposalsColor = colors.blue500;
export const getLegendItems = (texts)=>[
        {
            label: texts.activeAgreements(),
            color: agreementsColor
        },
        {
            label: texts.proposalsAwaitingApproval(),
            color: proposalsColor
        }
    ];
export const getTooltipItems = (payload, texts)=>{
    if (!payload || !payload.length) return;
    const historicAgreementStatsModel = payload[0].payload;
    return [
        {
            label: texts.proposalsAwaitingApprovalWithCount({
                count: utils.formatNumberWithCommas(historicAgreementStatsModel.proposalsCount())
            }),
            color: proposalsColor
        },
        {
            label: texts.activeAgreementsWithCount({
                count: utils.formatNumberWithCommas(historicAgreementStatsModel.agreementsCount())
            }),
            color: agreementsColor
        }
    ];
};
export const getTooltipTitle = (_label, payload)=>{
    if (!payload || !payload.length) return '';
    return format(payload[0].payload.date(), 'MMMM');
};
